import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';

export default function Preloader() {
  const [fade, setFade] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setFade(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        bgcolor: '#05080F',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000,
        opacity: fade ? 0 : 1,
        transition: 'opacity 1s',
        pointerEvents: fade ? 'none' : 'auto',
      }}
    >
      <Box sx={{ textAlign: 'center' }}>
        <img
          src={process.env.PUBLIC_URL + '/images/favicon.svg'}
          alt="ConectaChurch"
          style={{
            height: 220,
            width: 'auto',
            zIndex: 2100,
            position: 'relative',
            filter: 'drop-shadow(0 0 30px rgba(0,241,167,0.45))',
          }}
        />
      </Box>
    </Box>
  );
}
